import React, { useEffect, useState } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { moreTenThousand, countTimes, getQuery, voteApi, setLocalStorage, getLocalStorage } from '@src/utils';
// import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { type Post, type FeedFlowItem } from '@src/services/interface';
import { type callAppParmam, type statisticsParmam } from '@src/services/myInterface';
import Toast from '../toast';

type voteProps = {
    content: {
        isFeed: boolean;
        hasVote: Post['hasVote'];
        type: FeedFlowItem['type'];
        vote?: Post['vote'];
        callAppData?: callAppParmam;
        statisticsData?: statisticsParmam;
    };
};

type typeToastData = {
    isVoteSuccess: boolean;
    isShowToast: boolean;
    toastText: string;
};

const Vote = ({ content }: voteProps) => {
    const [ toastData, setToastData ] = useState({
        isVoteSuccess: false,
        isShowToast: false,
        toastText: ''
    });
    const [ activeOption, setActiveOption ] = useState('');
    const isFeed = content.isFeed;
    const type = content?.type;
    const hasVote = content.hasVote;
    const vote = content?.vote;
    const option = vote?.option || [];
    const votecount = vote?.votecount || 0;
    const endtime = vote?.endtime;
    const isExpire = vote?.expire;
    let expireDate = '';
    const voteEndText = '投票已结束';
    const allNum = toastData.isVoteSuccess && activeOption ?  Number(votecount) + 1 : votecount;

    if (vote?.expireType !== '0' && endtime) {
        if(countTimes(endtime).includes('-')) {
            expireDate = voteEndText;
        } else {
            expireDate = `${countTimes(endtime)}后结束`;
        }
    }
    if (isExpire === '0') {
        expireDate = voteEndText;
    }
    const percentages: number[] = [];
    const bigBangVoteList = getLocalStorage('bigBangVoteList') || [];

    // const userId = getQuery(window.location.href, 'userId') || '';
    // const defaultStatisticsData = {
    //     behavior: 'action',
    //     type: 'sharepage_app_start',
    //     button_name: 'c',
    //     user_id: userId,
    // };
    // const statisticsData = content.statisticsData || defaultStatisticsData || {};
    // const callAppData = content?.callAppData;
    // const wxLaunchHackData = {
    //     callAppConfig: callAppData,
    //     statisticsConfig: statisticsData,
    // };

    const setToastHandle = (value: typeToastData) => {
        setToastData(value)
    }
    const sendVote = async (itemid?: string) => {
        const keyString = `sur[${vote?.questionid}][]`;

        if(expireDate === voteEndText) {
            setToastData({
                isVoteSuccess: false,
                isShowToast: true,
                toastText: voteEndText
            });

            return false;
        }

        if(!itemid) {
            return false;
        }
        
        try {
            // @ts-ignore
            await voteApi.indexPhp.surveyPostsurveyList({
                    id: vote?.id || '',
                    ref: location.href,
                    [keyString]: itemid,
            }).then((res) => {
                if (res?.data?.ifsuccess === 1) {
                    setActiveOption(itemid);
                    setToastData({
                        isVoteSuccess: true,
                        isShowToast: false,
                        toastText: ''
                    });
                    bigBangVoteList.push({
                        voteId: vote?.id,
                        optionId: itemid
                    })

                    setLocalStorage('bigBangVoteList', bigBangVoteList)
                } else {
                    setToastData({
                        isVoteSuccess: false,
                        isShowToast: true,
                        toastText: '投票失败'
                    });
                }
            });
        }catch(e) {
            setToastData({
                isVoteSuccess: false,
                isShowToast: false,
                toastText: ''
            });
        }
    }

    const getLocalVote = async () => {
        bigBangVoteList.forEach((item: {
            voteId: string;
            optionId: string;
        }) => {
            if(item?.voteId && item?.voteId === vote?.id) {
                setActiveOption(item?.optionId || '');
            }
        });
    }

    useEffect(() => {
        getLocalVote();
    }, [])

    return hasVote ? (
        <div className={isFeed ? styles.feedVote : styles.articleVote}>
            {option.map((item, index) => {
                let percentageStr = '0%';
                const addNum = (activeOption === item.itemid && toastData.isVoteSuccess == true) ? 1 : 0;
                const liveNum = Number(item.num) + addNum;

                if (index !== option.length - 1) {
                    const percentageNum = Math.floor((liveNum / allNum) * 100);
                    percentageStr = `${percentageNum || 0}%`;
                    percentages.push(percentageNum);
                } else {
                    let sumNum = 0;

                    percentages.forEach((sumItem) => {
                        sumNum += sumItem;
                    });

                    if (sumNum) {
                        percentageStr = `${100 - sumNum}%`;
                    } else {
                        const percentageNum = Math.floor((liveNum / allNum) * 100);
                        percentageStr = `${percentageNum || 0}%`;
                    }
                }

                return (
                    toastData.isVoteSuccess || expireDate === voteEndText || activeOption ? 
                        (<div
                            key={item.itemid}
                            className={`${styles.option} ${activeOption === item.itemid ? styles.optionActive : ''}`}
                            onClick={() => {
                                sendVote();
                            }}
                        >
                            <div className={styles.optionShadow} style={{ width: percentageStr }}>
                                <div className={`${styles.optionShadowContent} ${toastData.isVoteSuccess ? styles.optionAnimation : ''}`} />
                            </div>
                            <div className={`${styles.optionText} ${toastData.isVoteSuccess ? styles.opacityAnimation : ''}`}>{item.title}</div>
                            <div className={`${styles.percentage} ${toastData.isVoteSuccess ? styles.opacityAnimation : ''}`}>
                                {percentageStr} {moreTenThousand(liveNum)}票
                            </div>
                        </div>)
                    : (<div key={item.itemid} className={styles.defaultOption}>
                        <div className={styles.optionTitle} onClick={() => {
                            sendVote(item.itemid)
                        }}>{item.title}</div>
                    </div>)
                );
            })}
            {type !== 'predict' ? (
                <div className={styles.info}>
                    <div className={styles.join}>{moreTenThousand(allNum)}人参与</div>
                    <div className={styles.state}>{expireDate}</div>
                </div>
            ) : null}
            {toastData.isShowToast && <Toast content={{
                    text: toastData.toastText,
                    setToastHandle: setToastHandle,
            }} />}
            {/* <WxLaunchHack content={wxLaunchHackData} /> */}
        </div>
    ) : null;
};

export default errorBoundary(Vote);
